import { createSelector } from 'reselect';

export const initialisedSelector = createSelector(
  (state) => state.app.initialised,
  (initialised) => initialised
);

export const loadingSelector = createSelector(
  (state) => state.app.loading,
  (loading) => loading
);

export const getLabels = createSelector(
  (state) => state.app.data.labels,
  (labels) => labels
);

export const basepathSelector = createSelector(
  (state) => state.app.basepath,
  (basepath) => {
    if (basepath && basepath[basepath.length - 1] === '/') {
      basepath = basepath.substr(0, basepath.length - 1); // eslint-disable-line
    }
    return basepath;
  }
);

export const getErrorSelector = createSelector(
  (state) => state.app.error,
  (error) => error
);

export const getBasket = createSelector(
  (state) => state.app.basket,
  (basket) => basket
);

export const getBasketSummary = createSelector(
  (state) => state.app.basketSummary,
  (basketSummary) => basketSummary
);

export const getCatalogList = createSelector(
  (state) => state.app.catalogList,
  (catalogList) => catalogList
);

export const getBike = createSelector(
  (state) => state.app.bike,
  (bike) => bike
);

export const getPartsList = createSelector(
  (state) => state.app.partsList,
  (partsList) => partsList
);

export const getHighlightedPart = createSelector(
  (state) => state.app.highlightedPart,
  (highlightedPart) => highlightedPart
);

export const getPartsModalPage = createSelector(
  (state) => state.app.partsModalPage,
  (partsModalPage) => partsModalPage
);

export const getDeliveryMethod = createSelector(
  (state) => state.app.deliveryMethod,
  (deliveryMethod) => deliveryMethod
);

export const getGeolocation = createSelector(
  (state) => state.app.geolocation,
  (geolocation) => geolocation
);

export const getSelectedDealer = createSelector(
  (state) => state.app.selectedDealer,
  (selectedDealer) => selectedDealer
);

export const getStep = createSelector(
  (state) => state.app.step,
  (step) => step
);

export const getCompletedSteps = createSelector(
  (state) => state.app.completedSteps,
  (completedSteps) => completedSteps
);

export const getFormData = createSelector(
  (state) => state.app.form,
  (formData) => formData
);

export const getLoadedConfiguration = createSelector(
  (state) => state.app.configuration,
  (configuration) => configuration
);

export const currencyCodeSelector = createSelector(
  (state) => state.app.data.currency,
  (currencyCode) => currencyCode
);

export const getSummary = createSelector(
  (state) => state.app.data.summary,
  (summary) => summary
);

export const getCtas = createSelector(
  (state) => state.app.data.ctas,
  (ctas) => ctas
);

export const getFaqs = createSelector(
  (state) => state.app.data.faqs,
  (faqs) => faqs
);
